module.exports = __webpack_public_path__ + "static/media/tour.ef81c099.jpg";